import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'

export const STEPS_INTL_2: TStep[] = [
  {
    pageId: PageId.ANALYZING_INTL_2,
  },
  {
    pageId: PageId.START_INTL_2,
  },
  {
    pageId: PageId.QUESTION_1_INTL_2,
  },
  {
    pageId: PageId.QUESTION_2_INTL_2,
  },
  {
    pageId: PageId.QUESTION_3_INTL_2,
  },
  {
    pageId: PageId.QUESTION_4_INTL_2,
  },
  {
    pageId: PageId.SPEED_FEEDBACK_INTL_2,
  },
  {
    pageId: PageId.QUESTION_5_INTL_2,
  },
  {
    pageId: PageId.QUESTION_6_INTL_2,
  },
  {
    pageId: PageId.QUESTION_7_INTL_2,
  },
  {
    pageId: PageId.QUESTION_8_INTL_2,
  },
  {
    pageId: PageId.QUESTION_9_INTL_2,
  },
  {
    pageId: PageId.QUESTION_10_INTL_2,
  },
  {
    pageId: PageId.QUESTION_11_INTL_2,
  },
  {
    pageId: PageId.QUESTION_12_INTL_2,
  },
  {
    pageId: PageId.SMARTNESS_FEEDBACK_INTL_2,
  },
  {
    pageId: PageId.QUESTION_13_INTL_2,
  },
  {
    pageId: PageId.QUESTION_14_INTL_2,
  },
  {
    pageId: PageId.QUESTION_15_INTL_2,
  },
  {
    pageId: PageId.QUESTION_16_INTL_2,
  },
  {
    pageId: PageId.QUESTION_17_INTL_2,
  },
  {
    pageId: PageId.QUESTION_18_INTL_2,
  },
  {
    pageId: PageId.QUESTION_19_INTL_2,
  },
  {
    pageId: PageId.QUESTION_20_INTL_2,
  },
  {
    pageId: PageId.LOGICAL_SKILLS_FEEDBACK_INTL_2,
  },
  {
    pageId: PageId.QUESTION_21_INTL_2,
  },
  {
    pageId: PageId.QUESTION_22_INTL_2,
  },
  {
    pageId: PageId.QUESTION_23_INTL_2,
  },
  {
    pageId: PageId.QUESTION_24_INTL_2,
  },
  {
    pageId: PageId.QUESTION_25_INTL_2,
  },
  {
    pageId: PageId.AGE_QUESTION_INTL_2,
  },
  {
    pageId: PageId.EDUCATION_QUESTION_INTL_2,
  },
  {
    pageId: PageId.DISCOVER_FEEDBACKS_INTL_2,
  },
  {
    pageId: PageId.PREPARE_FLOW_INTL_2,
  },
  {
    pageId: PageId.EMAIL_INTL_2,
  },
  {
    pageId: PageId.EMAIL_CONSENT_INTL_2,
  },
  {
    pageId: PageId.OFFER_INTL_2,
  },
  {
    pageId: PageId.SPECIAL_DISCOUNT_INTL_2,
  },
  {
    pageId: PageId.CANCEL_OFFER_INTL_2,
  },
  {
    pageId: PageId.PAYMENT_INTL_2,
  },
  {
    pageId: PageId.CHECKOUT_INTL_2,
  },
  {
    pageId: PageId.UPSELL_INTL_2,
  },
  {
    pageId: PageId.REGISTRATION_INTL_2,
  },
  {
    pageId: PageId.NAME_ENTRY_INTL_2,
  },
  {
    pageId: PageId.CERTIFICATE_INTL_2,
  },
  {
    pageId: PageId.REPORT_INTL_2,
  },
]
